import { render, staticRenderFns } from "./MyOrderDetails.vue?vue&type=template&id=36e1e849&scoped=true"
import script from "./MyOrderDetails.vue?vue&type=script&lang=js"
export * from "./MyOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./MyOrderDetails.vue?vue&type=style&index=0&id=36e1e849&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e1e849",
  null
  
)

export default component.exports